import { getDescription } from "../../../utils/DocumentUtil";

const baseObject = {
  fileName: "",
  fileBase64: "",
  documentType: "",
  documentSubtype: "",
  description: "",
  emissionDate: "",
  dueDate: "",
  competence: "",
  grossAmount: "",
  netAmount: "",
  discountAmount: "",
  fineAmount: "",
  interestAmount: "",
  movementType: "",
  relatedEntity: {
    name: "",
    document: "",
  },
};

export const convertDocumentData = (document) => {
  switch (document.data.document_type) {
    case "NOT_IDENTIFIED":
      return convertNotIdentifiedData(document);
    case "DARF":
      return convertDarfData(document);
    case "DAS":
      return convertDasData(document);
    case "FGTS":
      return convertFgtsData(document);
    case "BOLETO":
      return convertBoletoData(document);
    default:
      return convertNotIdentifiedData(document);
  }
};

const convertDarfData = (document) => {
  let resultObj = { ...baseObject };

  resultObj.fileName = document?.name;
  resultObj.fileBase64 = document?.base64;
  resultObj.documentType = "DARF";
  resultObj.documentSubtype = null;
  resultObj.description = getDescription(document?.data?.code_receita);
  resultObj.emissionDate = document?.data?.emission_date;
  resultObj.dueDate = document?.data?.expire_date;
  resultObj.competence = document?.data?.period;
  resultObj.grossAmount = document?.data?.principal_amount || 0;
  resultObj.fineAmount = document?.data?.penalty_amount || 0;
  resultObj.interestAmount = document?.data?.tax_amount || 0;
  resultObj.netAmount = document?.data?.total_amount || 0;
  resultObj.discountAmount = document?.data?.discount_amount || 0;
  resultObj.movementType = "PAYABLE";
  resultObj.folderSystem = "fiscal";
  resultObj.folderType = "guide";

  if (typeof resultObj.grossAmount === "string") {
    resultObj.grossAmount = Number(
      resultObj.grossAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.fineAmount === "string") {
    resultObj.fineAmount = Number(
      resultObj.fineAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.interestAmount === "string") {
    resultObj.interestAmount = Number(
      resultObj.interestAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.netAmount === "string") {
    resultObj.netAmount = Number(
      resultObj.netAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.discountAmount === "string") {
    resultObj.discountAmount = Number(
      resultObj.discountAmount.replace(".", "").replace(",", ".")
    );
  }

  //   SEARCH CLIENT
  resultObj.relatedEntity = {
    name: "MINISTERIO DA FAZENDA",
    document: "00394460005887",
  };

  resultObj.relatedEntityDisabled = true;

  return resultObj;
};

const convertDasData = (document) => {
  let resultObj = { ...baseObject };

  resultObj.fileName = document?.name;
  resultObj.fileBase64 = document?.base64;
  resultObj.documentType = "DAS";
  resultObj.documentSubtype = null;
  resultObj.description = "DAS " + document?.data?.doc_number;
  resultObj.emissionDate = document?.data?.emission_date;
  resultObj.dueDate = document?.data?.expire_date;
  resultObj.competence = document?.data?.period;
  resultObj.grossAmount = document?.data?.principal_amount || 0;
  resultObj.fineAmount = document?.data?.penalty_amount || 0;
  resultObj.interestAmount = document?.data?.tax_amount || 0;
  resultObj.discountAmount = document?.data?.discount_amount || 0;
  resultObj.netAmount = document?.data?.total_amount || 0;
  resultObj.movementType = "PAYABLE";
  resultObj.folderSystem = "fiscal";
  resultObj.folderType = "guide";

  if (typeof resultObj.grossAmount === "string") {
    resultObj.grossAmount = Number(
      resultObj.grossAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.fineAmount === "string") {
    resultObj.fineAmount = Number(
      resultObj.fineAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.interestAmount === "string") {
    resultObj.interestAmount = Number(
      resultObj.interestAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.netAmount === "string") {
    resultObj.netAmount = Number(
      resultObj.netAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.discountAmount === "string") {
    resultObj.discountAmount = Number(
      resultObj.discountAmount.replace(".", "").replace(",", ".")
    );
  }

  resultObj.relatedEntity = {
    name: "DAS - Documento de Arrecadação do Simples Nacional",
    document: "99999999000191",
  };

  resultObj.relatedEntityDisabled = true;

  return resultObj;
};

const convertFgtsData = (document) => {
  let resultObj = { ...baseObject };

  resultObj.fileName = document?.name;
  resultObj.fileBase64 = document?.base64;
  resultObj.documentType = "FGTS";
  resultObj.documentSubtype = null;
  resultObj.description = "FGTS " + document?.data?.govid;
  resultObj.emissionDate = document?.data?.emission_date;
  resultObj.dueDate = document?.data?.expire_date;
  resultObj.competence = document?.data?.period;
  resultObj.grossAmount = document?.data?.total_amount || 0;
  resultObj.netAmount = document?.data?.total_amount || 0;
  resultObj.discountAmount = 0;
  resultObj.fineAmount = 0;
  resultObj.interestAmount = 0;
  resultObj.folderSystem = "fiscal";
  resultObj.folderType = "guide";

  resultObj.movementType = "PAYABLE";

  if (typeof resultObj.grossAmount === "string") {
    resultObj.grossAmount = Number(
      resultObj.grossAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.fineAmount === "string") {
    resultObj.fineAmount = Number(
      resultObj.fineAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.interestAmount === "string") {
    resultObj.interestAmount = Number(
      resultObj.interestAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.netAmount === "string") {
    resultObj.netAmount = Number(
      resultObj.netAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.discountAmount === "string") {
    resultObj.discountAmount = Number(
      resultObj.discountAmount.replace(".", "").replace(",", ".")
    );
  }

  // DEFINIR DOCUMENTO E NOME
  resultObj.relatedEntity = {
    name: "",
    document: "",
  };

  resultObj.relatedEntityDisabled = true;

  return resultObj;
};

const convertBoletoData = (document) => {
  let resultObj = { ...baseObject };

  resultObj.fileName = document?.name;
  resultObj.fileBase64 = document?.base64;
  resultObj.documentType = "BOLETO";
  resultObj.documentSubtype = null;
  resultObj.description = document?.data?.typeable_line;
  resultObj.emissionDate = "";

  if (document?.data?.data?.paymentDetails?.dueDate) {
    resultObj.dueDate = isoToBrDate(
      document?.data?.data?.paymentDetails?.dueDate
    );
    resultObj.emissionDate = resultObj.dueDate;
    resultObj.competence = resultObj.dueDate.substring(3);
  }

  resultObj.grossAmount =
    document?.data?.data?.paymentDetails?.totalAmount || 0;
  resultObj.fineAmount = document?.data?.data?.paymentDetails?.fine || 0;
  resultObj.interestAmount =
    document?.data?.data?.paymentDetails?.interest || 0;
  resultObj.discountAmount =
    document?.data?.data?.paymentDetails?.discount || 0;

  resultObj.netAmount =
    document?.data?.data?.paymentDetails?.consolidatedAmount ||
    document?.data?.data?.paymentDetails?.totalAmount ||
    0;

  resultObj.folderSystem = "fiscal";
  resultObj.folderType = "guide";

  resultObj.movementType = "PAYABLE";

  if (typeof resultObj.grossAmount === "string") {
    resultObj.grossAmount = Number(
      resultObj.grossAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.fineAmount === "string") {
    resultObj.fineAmount = Number(
      resultObj.fineAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.interestAmount === "string") {
    resultObj.interestAmount = Number(
      resultObj.interestAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.netAmount === "string") {
    resultObj.netAmount = Number(
      resultObj.netAmount.replace(".", "").replace(",", ".")
    );
  }

  if (typeof resultObj.discountAmount === "string") {
    resultObj.discountAmount = Number(
      resultObj.discountAmount.replace(".", "").replace(",", ".")
    );
  }

  resultObj.relatedEntity = {
    name: document?.data?.data?.beneficiary?.name,
    document: document?.data?.data?.beneficiary?.taxIdentifier?.taxId,
  };

  resultObj.supplierName = document?.data?.data?.beneficiary?.name;
  resultObj.supplierDocument =
    document?.data?.data?.beneficiary?.taxIdentifier?.taxId;

  return resultObj;
};

const convertNotIdentifiedData = (document) => {
  let resultObj = { ...baseObject };

  resultObj.fileName = document?.name;
  resultObj.fileBase64 = document?.base64;
  resultObj.documentType = "OTHER";
  resultObj.documentSubtype = null;
  resultObj.description = "DOCUMENTO NÃO IDENTIFICADO";
  resultObj.folderSystem = "outros";
  resultObj.folderType = "doc";

  return resultObj;
};

export const getRelatedEntityOfDocumentType = (documentType) => {
  switch (documentType?.name) {
    case "DARF":
      return {
        name: "MINISTERIO DA FAZENDA",
        document: "00394460005887",
        movementType: "PAYABLE",
        disabled: true,
      };

    case "DAS":
      return {
        name: "DAS - Documento de Arrecadação do Simples Nacional",
        document: "99999999000191",
        movementType: "PAYABLE",
        disabled: true,
      };

    case "GARE":
      return {
        name: "SECRETARIA DA FAZENDA E PLANEJAMENTO",
        document: "46377222000129",
        movementType: "PAYABLE",
        disabled: true,
      };

    default:
      return null;
  }
};

export const getFolderDataOfDocumentType = (documentType) => {
  switch (documentType.name) {
    case "DARF":
      return {
        folderSystem: "fiscal",
        folderType: "guide",
      };

    case "DAS":
      return {
        folderSystem: "fiscal",
        folderType: "guide",
      };

    case "FGTS":
      return {
        folderSystem: "fiscal",
        folderType: "guide",
      };

    case "BOLETO":
      return {
        folderSystem: "fiscal",
        folderType: "guide",
      };

    case "NOT_IDENTIFIED":
      return {
        folderSystem: "outros",
        folderType: "doc",
      };

    case "OTHER":
      return {
        folderSystem: "outros",
        folderType: "doc",
      };

    default:
      return {
        folderSystem: "outros",
        folderType: "doc",
      };
  }
};

export const convertDate = (date) => {
  if (!date) {
    return "";
  }

  return (
    date.substring(6) + "-" + date.substring(3, 5) + "-" + date.substring(0, 2)
  );
};

export const convertCompetence = (competence) => {
  if (!competence) {
    return "";
  }
  return competence.substring(3, 7) + "-" + competence.substring(0, 2);
};

export const isoToBrDate = (date) => {
  if (!date) {
    return "";
  }

  return (
    date.substring(8) + "/" + date.substring(5, 7) + "/" + date.substring(0, 4)
  );
};

export const getDocumentTypeMovementType = (documentType) => {
  switch (documentType) {
    case "DARF":
      return "PAYABLE";
    case "DAS":
      return "PAYABLE";
    case "FGTS":
      return "PAYABLE";
    case "BOLETO":
      return "PAYABLE";
    case "NOT_IDENTIFIED":
      return null;
    case "OTHER":
      return null;
    default:
      return null;
  }
};
